/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Block_RedInputs */

const en_orders_review_block_red = /** @type {(inputs: Orders_Review_Block_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order is marked red and must stay on hold.`)
};

const es_orders_review_block_red = /** @type {(inputs: Orders_Review_Block_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El pedido esta marcado en rojo y debe permanecer en espera.`)
};

/**
* | output |
* | --- |
* | "Order is marked red and must stay on hold." |
*
* @param {Orders_Review_Block_RedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_block_red = /** @type {((inputs?: Orders_Review_Block_RedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Block_RedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_block_red(inputs)
	return es_orders_review_block_red(inputs)
});